/*
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 *
 */
import api from '@/utils/api.request';

// 获取项目列表
export const projectList = (param) => {
    return api.request({
        url: 'frontend/project/list',
        method: 'get',
        params: param
    });
};

// 获取所有项目
export const projectAll = (param) => {
    return api.request({
        url: 'frontend/project/all',
        method: 'get',
        params: param
    });
};

// 报名统计
export const projectStatistics = (param) => {
    return api.request({
        url: 'frontend/project/statistics',
        method: 'get',
        params: param
    });
};

// 获取项目详情
export const projectDetail = (param) => {
    return api.request({
        url: 'frontend/project/detail',
        method: 'get',
        params: param
    });
};

// 获取单位信息
export const projectUnitInfo = (param) => {
    return api.request({
        url: 'frontend/project/ownerUnit',
        method: 'get',
        params: param
    });
};

// 获取报名信息
export const projectApplicationInfo = (param) => {
    return api.request({
        url: 'frontend/project/application/info',
        method: 'get',
        params: param
    });
};

// 获取项目协议
export const projectAgreement = (param) => {
    return api.request({
        url: 'frontend/project/agreement',
        method: 'get',
        params: param
    });
};

// 同意协议
export const projectAgreementAgree = (param) => {
    return api.request({
        url: 'frontend/project/agreement/agree',
        method: 'get',
        params: param
    });
};

// 获取导航
export const projectApplyNav = (param) => {
    return api.request({
        url: 'frontend/project/apply/nav',
        method: 'get',
        params: param
    });
};

// 获取职位列表
export const projectJobList = (param) => {
    return api.request({
        url: 'frontend/project/job/list',
        method: 'get',
        params: param
    });
};

// 获取职位详情
export const projectJobInfo = (param) => {
    return api.request({
        url: 'frontend/project/job/info',
        method: 'get',
        params: param
    });
};

// 预览报名表
export const projectApplyPreview = (param) => {
    return api.request({
        url: 'frontend/project/apply/form/preview',
        method: 'get',
        params: param
    });
};

// 获取报名信息
export const projectApplyInfo = (param) => {
    return api.request({
        url: 'frontend/project/apply/info',
        method: 'get',
        params: param
    });
};

// 保存报名信息
export const projectApplySave = (data) => {
    return api.request({
        url: 'frontend/project/apply/save',
        data,
        method: 'post'
    });
};

// 暂存报名信息
export const projectApplySaveTs = (data) => {
    return api.request({
        url: 'frontend/project/apply/save/ts',
        data,
        method: 'post'
    });
};

// 简历同步
export const projectApplySyncResumes = (param) => {
    return api.request({
        url: 'frontend/project/apply/sync/resumes',
        method: 'get',
        params: param
    });
};


// 查询报考结果
export const projectApplyResult = (param) => {
    return api.request({
        url: 'frontend/project/apply/result',
        method: 'get',
        params: param
    });
};

// 查看报名表
export const projectApplyTmp = (param) => {
    return api.request({
        url: 'frontend/project/apply/tmp',
        method: 'get',
        params: param
    });
};

// 查看缴费详情
export const projectApplyPayDetail = (param) => {
    return api.request({
        url: 'frontend/project/apply/pay/detail',
        method: 'get',
        params: param
    });
};

// 查看打印信息
export const projectApplyEadDetail = (param) => {
    return api.request({
        url: 'frontend/project/apply/ead/detail',
        method: 'get',
        params: param
    });
};

// 打印预览
export const projectApplyViewPrint = (param) => {
    return api.request({
        url: 'frontend/project/apply/view/print',
        method: 'get',
        params: param
    });
};

// 查看成绩（结果）
export const projectApplyScore = (param) => {
    return api.request({
        url: 'frontend/project/apply/score',
        method: 'get',
        params: param
    });
};


// 是否重复报名
export const repetition = (param) => {
    return api.request({
        url: 'frontend/project/apply/repetition',
        method: 'get',
        params: param
    });
};
